import React from "react";
import { Trans } from "react-i18next";
import { t } from "js/i18n";
const ManageAccountLink = (props: { children?: React.ReactNode }) => (
    <a
        href="https://support.beautiful.ai/hc/en-us/sections/360006956931-Managing-your-Billing"
        target="_blank"
        rel="noreferrer"
    >
        {props.children}
    </a>
);
type Props = {
daysUntilDowngrade: number;
};

export function PaymentIssueDialogMessage({ daysUntilDowngrade }: Props) {
    return (
        <Trans
            i18nKey="You have <bold>{{days}} days</bold> to update your payment information before your account is downgraded. Learn more about managing your account <manageAccountLink>here</manageAccountLink>."
            components={{
                bold: <b />,
                manageAccountLink: <ManageAccountLink />
            }}
            values={{ days: daysUntilDowngrade }}
        />
    );
}
